import 'stylesheets/application.scss';
import '@hotwired/turbo-rails';

import * as ActiveStorage from "@rails/activestorage";

import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";

import 'lib/sentry';
import { setupTurboAutoFocuser } from 'lib/turbo_helpers';

const application = Application.start();

const context = require.context("controllers/application", true, /\.js$/);
const commonContext = require.context("controllers/common", true, /\.js$/);

application.load(definitionsFromContext(context));
application.load(definitionsFromContext(commonContext));
application.stimulusUseDebug = !!document.documentElement.dataset.debug;

ActiveStorage.start();

setupTurboAutoFocuser();
